// const email = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
const email = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,}$/;
const mobile =/(iPhone|iOS|Android)/i;
const number =/^(\d+)$/;
const phone = /^[1][2,3,4,5,6,7,8,9]\d{9}$/;
const mbtSn = /^34[a-zA-Z0-9]{0,20}$/;
const amount = /^-?(0|[1-9]\d*)(\.\d{1,2})?$/;
const password = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+=[\]{};':"\\|,.<>/?`~-])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?`~-]{8,16}$/
const isCustomize = (value, reg) => {
    const regex = new RegExp(reg, "g");
    return regex.test(value);
}
export default {
    mobile,
    email,
    password,
    number,
    phone,
    amount,
    isEmail: email,
    isNumber: number,
    isPhone: phone,
    isMbtSn: mbtSn,
    isCustomize
}